import { cn } from "@/lib/utils";

/** Teller ved siden av et menyvalg (uleste i Chat, VIB-3022). Rendres ikke når tallet er 0. */
export function NavBadge({ count, collapsed = false }: { count?: number; collapsed?: boolean }) {
  if (!count) return null;
  const label = count > 99 ? "99+" : String(count);
  return (
    <span
      aria-label={`${count} uleste`}
      className={cn(
        "flex h-5 min-w-[20px] items-center justify-center rounded-full bg-primary px-1.5 text-[11px] font-semibold text-primary-foreground",
        collapsed ? "absolute right-1.5 top-0.5 h-4 min-w-[16px] px-1 text-[10px]" : "ml-auto",
      )}
    >
      {label}
    </span>
  );
}
